export const GET_CLAIM_SIMPLIFIED_UI = 'GET_CLAIM_SIMPLIFIED_UI';
